module.exports = "<div class=header data-component=header></div>";